import React, { useEffect } from "react";
import Table from 'react-bootstrap/Table';
import moment from 'moment';

const Speed = (props) => {
    const {
        counts,
        formatDate,
        avg_excluding_zeros,
        speed,
        setSpeed,
        speedUnit
     } = props

         // SPEED START
    // --------------------------
    useEffect(() => {
        // Speed
        const getSpeed = () => {

            let arr = [];

            let speed_unit = 1
            // console.log(speedUnit)
            switch (speedUnit){
                case 'ms':
                    speed_unit = 3.6
                    break;
                case 'mph':
                    speed_unit = 1.60934
                    break;
                default:
                    speed_unit = 1
            }

            //Filter Vehicles SPEED. Exclude PEDESTRIANS
            for (let i = 0; i < counts.length; i++){
                const arrSpeed = counts[i].entries
                    .map(obj => {return { date_iso: counts[i].date_iso, SPEED: obj.SPEED * speed_unit, CLASS: obj.CLASS}})
                    .filter(item => {return item.CLASS !== 'PEDESTRIAN' && item.CLASS !== 'BIKE' && item.SPEED !== 0})

                // console.log(arrSpeed)
                // console.log(arrSpeed)
                let avg = {}
                if (arrSpeed.length > 0)
                    avg = {
                        date_iso: arrSpeed[0].date_iso,
                        SPEED: avg_excluding_zeros(arrSpeed.map(i => i.SPEED))
                    } 

                if (avg.SPEED)
                    arr = [...arr, avg];
            }
            setSpeed(arr);
        }

        getSpeed();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts, avg_excluding_zeros, setSpeed]);
    // SPEED END

return (
    <div className="row p-2">
        <div className="col-md-12">
        <h2 className="text-header">Speed</h2>
        <div className="text-description small pb-3">
        average speed in km/h 
        </div>
        <div className="row">

            <div className="col-md-12">
            <Table responsive hover className="small p-0 border">
            <thead>
                <tr>
                <th className="table-th-det">Date</th>
                <th className="table-th-det">Time</th>
                <th className="table-th-det">Speed [km/h]</th>
                </tr>
            </thead>
            <tbody>

            {speed.map((x, i) =>
            <tr key={i} className="table-tr">
                <td className="table-td">{ moment.utc(x.date_iso).local().format(formatDate[0])}</td>
                <td className="table-td">{
                parseInt(moment.utc(x.date_iso).local().format('HH'))+":00 - "
                + (parseInt(moment.utc(x.date_iso).local().format('HH'))+1)+":00"
                }</td>
                <td className="table-td">{parseFloat(x.SPEED).toFixed(2)}</td>
            </tr>
            )}

            </tbody>
            </Table>
            </div>
        </div>
        </div>
    </div>
)}

export default Speed;